<template>
    <div>
        <b-card :style="{'width': '96%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px' }">
            <!-- Header Section -->
            <b-card-text style="margin: 10px;">
                <h4>Reports - Salespeople</h4>
                <small class="text-muted" v-if="picked_sale_type === 'layaway'">
                    <i class="fas fa-shopping-basket text-warning"></i>
                    Currently viewing LAYAWAY SALES only
                </small>
                <small class="text-muted" v-else-if="picked_sale_type === 'regular'">
                    <i class="fas fa-receipt text-primary"></i>
                    Currently viewing REGULAR SALES only
                </small>
                <small class="text-muted" v-else>
                    <i class="fas fa-chart-bar text-info"></i>
                    Viewing ALL SALE TYPES
                </small>
            </b-card-text>

            <!-- Filters Section -->
            <b-card no-body class="mb-3" style="border: 1px solid #e0e0e0;">
                <b-card-body class="p-3">
                    <!-- Date Controls -->
                    <div class="filter-group mb-3">
                        <label class="filter-label">Date Range</label>
                        <div class="d-flex flex-wrap align-items-center" style="gap: 5px;">
                            <date-picker
                                v-model="date_range"
                                format="MM-DD-YYYY"
                                valueType="format"
                                style="width: 220px; font-size: 12px;"
                                range
                            ></date-picker>
                            <b-button size="md" variant="success" @click="fetch_init">Search</b-button>
                        </div>
                    </div>

                    <!-- Quick Date Buttons -->
                    <div class="filter-group mb-3">
                        <label class="filter-label">Quick Dates</label>
                        <div class="d-flex flex-wrap" style="gap: 5px;">
                            <b-button size="sm" class="quick-date-btn" :pressed="picked_date_range=='today'" @click="set_dates('today')">Today</b-button>
                            <b-button size="sm" class="quick-date-btn" :pressed="picked_date_range=='yesterday'" @click="set_dates('yesterday')">Yesterday</b-button>
                            <b-button size="sm" class="quick-date-btn" :pressed="picked_date_range=='this_week'" @click="set_dates('this_week')">This Week</b-button>
                            <b-button size="sm" class="quick-date-btn" :pressed="picked_date_range=='last_week'" @click="set_dates('last_week')">Last Week</b-button>
                            <b-button size="sm" class="quick-date-btn" :pressed="picked_date_range=='this_month'" @click="set_dates('this_month')">This Month</b-button>
                            <b-button size="sm" class="quick-date-btn" :pressed="picked_date_range=='last_month'" @click="set_dates('last_month')">Last Month</b-button>
                        </div>
                    </div>

                    <!-- Additional Filters -->
                    <div class="filter-group">
                        <div class="d-flex flex-wrap" style="gap: 5px;">
                            <div style="flex: 1 1 18%; gap: 5px; min-width: 150px;">
                                <label class="filter-label">Report Type</label>
                                <b-form-select
                                    :options="details"
                                    v-model="details_filter"
                                    @change="fetch_init"
                                    size="sm"
                                >
                                    <template #first>
                                        <b-form-select-option value="null">SELECT ANY</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                            <div style="flex: 1 1 18%; gap: 5px; min-width: 150px;">
                                <label class="filter-label">Location</label>
                                <b-form-select
                                    :options="filteredLocations"
                                    v-model="picked_location_id"
                                    size="sm"
                                    @change="fetch_init"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null">All Locations</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                            <div style="flex: 1 1 18%; gap: 5px; min-width: 150px;">
                                <label class="filter-label">Salesperson</label>
                                <b-form-select
                                    :options="salespersonOptions"
                                    v-model="picked_salesperson"
                                    size="sm"
                                    @change="fetch_init"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null">All Salespeople</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                            <div style="flex: 1 1 18%; gap: 5px; min-width: 150px;">
                                <label class="filter-label">Invoice Type</label>
                                <b-form-select
                                    :options="invoice_options"
                                    v-model="picked_invoice_type"
                                    @change="fetch_init()"
                                    size="sm"
                                >
                                    <template #first>
                                        <b-form-select-option value="null">All Types</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                            <div style="flex: 1 1 18%; gap: 5px; min-width: 150px;">
                                <label class="filter-label">Sale Type</label>
                                <b-form-select
                                    :options="sale_type_options"
                                    v-model="picked_sale_type"
                                    @change="fetch_init()"
                                    size="sm"
                                >
                                    <template #first>
                                        <b-form-select-option value="null">All Sale Types</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                        </div>
                    </div>
                </b-card-body>
            </b-card>

            <!-- Three Comparison Boxes -->
            <!-- Three Comparison Boxes - UPDATED STYLING -->
<div class="row mb-3">
    <!-- Sales Comparison Box -->
    <div class="col-md-4 mb-3">
        <b-card class="h-100 comparison-card sales-card">
            <b-card-body class="comparison-body">
                <h6 class="comparison-title text-primary mb-3">
                    <i class="fas fa-chart-line mr-2"></i>SALES
                </h6>

                <div class="comparison-grid">
                    <!-- Current vs Previous Period -->
                    <div class="periods-row mb-3">
                        <div class="period-box current-period">
                            <div class="period-label">Current Period</div>
                            <div class="period-value text-primary">{{ formatCurrency(salesComparison.currentTotal) }}</div>
                        </div>
                        <div class="period-box previous-period">
                            <div class="period-label">Previous Period</div>
                            <div class="period-value text-secondary">{{ formatCurrency(salesComparison.previousTotal) }}</div>
                        </div>
                    </div>

                    <!-- Difference & Growth -->
                    <div class="metrics-row">
                        <div class="metric-box difference">
                            <div class="metric-label">Difference</div>
                            <div class="metric-value" :class="salesComparison.trend === 'increase' ? 'text-success' : salesComparison.trend === 'decrease' ? 'text-danger' : 'text-muted'">
                                {{ formatCurrency(Math.abs(salesComparison.difference)) }}
                            </div>
                        </div>
                        <div class="metric-box growth">
                            <div class="metric-label">Growth</div>
                            <div class="metric-value" :class="salesComparison.trend === 'increase' ? 'text-success' : salesComparison.trend === 'decrease' ? 'text-danger' : 'text-muted'">
                                {{ salesComparison.percentage.toFixed(1) }}%
                                <i :class="salesComparison.trend === 'increase' ? 'fas fa-arrow-up' :
                                          salesComparison.trend === 'decrease' ? 'fas fa-arrow-down' :
                                          'fas fa-minus'"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Date Range Info -->
                <div class="date-info mt-3 pt-2 border-top">
                    <small class="text-muted">
                        <strong>Current:</strong> {{ getDateRangeText() }}<br>
                        <strong>Previous:</strong> {{ getPreviousDateRangeText() }}
                    </small>
                </div>
            </b-card-body>
        </b-card>
    </div>

    <!-- Refunds Comparison Box -->
    <div class="col-md-4 mb-3">
        <b-card class="h-100 comparison-card refunds-card">
            <b-card-body class="comparison-body">
                <h6 class="comparison-title text-danger mb-3">
                    <i class="fas fa-undo-alt mr-2"></i>REFUNDS
                </h6>

                <div class="comparison-grid">
                    <!-- Current vs Previous Period -->
                    <div class="periods-row mb-3">
                        <div class="period-box current-period">
                            <div class="period-label">Current Period</div>
                            <div class="period-value text-danger">{{ formatCurrency(refundsComparison.currentTotal) }}</div>
                        </div>
                        <div class="period-box previous-period">
                            <div class="period-label">Previous Period</div>
                            <div class="period-value text-secondary">{{ formatCurrency(refundsComparison.previousTotal) }}</div>
                        </div>
                    </div>

                    <!-- Difference & Growth -->
                    <div class="metrics-row">
                        <div class="metric-box difference">
                            <div class="metric-label">Difference</div>
                            <div class="metric-value" :class="refundsComparison.trend === 'increase' ? 'text-danger' : refundsComparison.trend === 'decrease' ? 'text-success' : 'text-muted'">
                                {{ formatCurrency(Math.abs(refundsComparison.difference)) }}
                            </div>
                        </div>
                        <div class="metric-box growth">
                            <div class="metric-label">Change</div>
                            <div class="metric-value" :class="refundsComparison.trend === 'increase' ? 'text-danger' : refundsComparison.trend === 'decrease' ? 'text-success' : 'text-muted'">
                                {{ refundsComparison.percentage.toFixed(1) }}%
                                <i :class="refundsComparison.trend === 'increase' ? 'fas fa-arrow-up' :
                                          refundsComparison.trend === 'decrease' ? 'fas fa-arrow-down' :
                                          'fas fa-minus'"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Date Range Info -->
                <div class="date-info mt-3 pt-2 border-top">
                    <small class="text-muted">
                        <strong>Current:</strong> {{ getDateRangeText() }}<br>
                        <strong>Previous:</strong> {{ getPreviousDateRangeText() }}
                    </small>
                </div>
            </b-card-body>
        </b-card>
    </div>

    <!-- Layaway Comparison Box -->
    <div class="col-md-4 mb-3">
        <b-card class="h-100 comparison-card layaway-card">
            <b-card-body class="comparison-body">
                <h6 class="comparison-title text-warning mb-3">
                    <i class="fas fa-shopping-basket mr-2"></i>LAYAWAY
                </h6>

                <div class="comparison-grid">
                    <!-- Current vs Previous Period -->
                    <div class="periods-row mb-3">
                        <div class="period-box current-period">
                            <div class="period-label">Current Period</div>
                            <div class="period-value text-warning">{{ formatCurrency(layawayComparison.currentTotal) }}</div>
                        </div>
                        <div class="period-box previous-period">
                            <div class="period-label">Previous Period</div>
                            <div class="period-value text-secondary">{{ formatCurrency(layawayComparison.previousTotal) }}</div>
                        </div>
                    </div>

                    <!-- Difference & Growth -->
                    <div class="metrics-row">
                        <div class="metric-box difference">
                            <div class="metric-label">Difference</div>
                            <div class="metric-value" :class="layawayComparison.trend === 'increase' ? 'text-success' : layawayComparison.trend === 'decrease' ? 'text-danger' : 'text-muted'">
                                {{ formatCurrency(Math.abs(layawayComparison.difference)) }}
                            </div>
                        </div>
                        <div class="metric-box growth">
                            <div class="metric-label">Growth</div>
                            <div class="metric-value" :class="layawayComparison.trend === 'increase' ? 'text-success' : layawayComparison.trend === 'decrease' ? 'text-danger' : 'text-muted'">
                                {{ layawayComparison.percentage.toFixed(1) }}%
                                <i :class="layawayComparison.trend === 'increase' ? 'fas fa-arrow-up' :
                                          layawayComparison.trend === 'decrease' ? 'fas fa-arrow-down' :
                                          'fas fa-minus'"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Date Range Info -->
                <div class="date-info mt-3 pt-2 border-top">
                    <small class="text-muted">
                        <strong>Current:</strong> {{ getDateRangeText() }}<br>
                        <strong>Previous:</strong> {{ getPreviousDateRangeText() }}
                    </small>
                </div>
            </b-card-body>
        </b-card>
    </div>
</div>

            <!-- Loading state for comparison -->
            <div v-if="comparisonLoading" class="mb-3 p-3 bg-light rounded text-center">
                <b-spinner small variant="primary" class="mr-2"></b-spinner>
                Loading comparison data...
            </div>

            <!-- Data Table -->
            <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                <div v-if="items.length > 0">
                    <!-- Data Table -->
                    <b-card no-body class="data-table-container">
                        <b-card-header class="py-2 d-flex justify-content-between align-items-center" style="background: #f8f9fa; font-weight: bold;">
                            <div>
                                <h6 class="mb-0">{{ getTableTitle() }}</h6>
                                <small class="text-muted">Showing {{ filteredItems.length }} records</small>
                                <small v-if="picked_sale_type === 'layaway'" class="text-warning ml-2">
                                    <i class="fas fa-shopping-basket"></i> Layaway Sales
                                </small>
                                <small v-else-if="picked_sale_type === 'regular'" class="text-primary ml-2">
                                    <i class="fas fa-receipt"></i> Regular Sales
                                </small>
                            </div>
                            <div class="text-muted" style="font-size: 12px;">
                                {{ getDateRangeText() }}
                            </div>
                        </b-card-header>

                        <div class="table-responsive">
                            <table class="table table-sm table-hover table-bordered mb-0" style="font-size: 13px;">
                                <thead class="table-light">
                                    <tr>
                                        <th v-for="col in allowed_cols()" :key="col"
                                            :class="getHeaderClass(col)"
                                            :style="getHeaderStyle(col)">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <span>{{ (fixed_columns_dict[col] || col ) }}</span>
                                                <b-button
                                                    v-if="isSortableColumn(col)"
                                                    variant="link"
                                                    size="sm"
                                                    class="p-0 ml-1 text-muted"
                                                    @click="sortByColumn(col)"
                                                >
                                                    <i class="fas fa-sort"></i>
                                                </b-button>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in paginatedItems" :key="idx"
                                        :class="getRowClass(item)">
                                        <td v-for="row_col in allowed_cols()" :key="row_col"
                                            :class="getCellClass(row_col, item[row_col])">
                                            <span v-if="row_col === 'salesperson'">
                                                {{ formatSalespersonName(item[row_col]) }}
                                            </span>
                                            <span v-else-if="row_col === 'location_name'">
                                                {{ packet.locationsdict[item.location_id] || `Location ${item.location_id}` }}
                                            </span>
                                            <span v-else-if="['invoice_id', 'lease_ids', 'lease_company'].includes(row_col)">
                                                {{ item[row_col] || '—' }}
                                            </span>
                                            <span v-else-if="row_col === 'total_sales_count'">
                                                {{ formatSalesCount(item[row_col]) }}
                                            </span>
                                            <span v-else-if="row_col === 'is_layaway'">
                                                <b-badge :variant="item[row_col] ? 'warning' : 'light'">
                                                    {{ item[row_col] ? 'Layaway' : 'Regular' }}
                                                </b-badge>
                                            </span>
                                            <!-- ADD THE NEW COLUMNS HERE -->
                                            <span v-else-if="row_col === 'net_sales'">
                                                {{ formatCurrency(item[row_col]) }}
                                            </span>
                                            <span v-else-if="row_col === 'layaway_paid_so_far'">
                                                {{ formatCurrency(item[row_col]) }}
                                            </span>
                                            <!-- END OF NEW COLUMNS -->
                                            <span v-else-if="typeof item[row_col] === 'number'">
                                                {{ formatCurrency(item[row_col]) }}
                                            </span>
                                            <span v-else>
                                                {{ (item[row_col] || 0.0).toFixed(2) }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                                <!-- Footer with Totals -->
                                <tfoot v-if="showFooter" class="table-warning">
                                    <tr>
                                        <td v-for="col in allowed_cols()" :key="'footer-' + col"
                                            class="fw-bold">
                                            <span v-if="col === 'salesperson'">TOTAL</span>
                                            <span v-else-if="col === 'locuser'">—</span>
                                            <span v-else-if="col === 'total_sales_count'">
                                                {{ formatSalesCount(columnTotal(col)) }}
                                            </span>
                                            <span v-else-if="col === 'is_layaway'">—</span>
                                            <span v-else-if="isNumericColumn(col)">
                                                {{ formatCurrency(columnTotal(col)) }}
                                            </span>
                                            <span v-else>—</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </b-card>

                    <!-- Pagination for large datasets -->
                    <div v-if="filteredItems.length > perPage" class="d-flex justify-content-between align-items-center mt-3">
                        <div class="text-muted" style="font-size: 12px;">
                            Showing {{ paginationStart }} to {{ paginationEnd }} of {{ filteredItems.length }} records
                        </div>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="filteredItems.length"
                            :per-page="perPage"
                            size="sm"
                            align="center"
                        ></b-pagination>
                    </div>
                </div>

                <!-- Empty State -->
                <div v-else-if="!items_being_loaded">
                    <b-alert show variant="warning" class="text-center">
                        <i class="fas fa-inbox fa-2x mb-2"></i>
                        <h5>No records found</h5>
                        <p class="mb-0">Try adjusting your filters or date range</p>
                        <p v-if="picked_sale_type === 'layaway'" class="mb-0">
                            <small>No layaway sales found for the selected criteria</small>
                        </p>
                    </b-alert>
                </div>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import moment from 'moment'
    import 'moment/locale/en-gb'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import JsonCSV from 'vue-json-csv'
    moment.locale('en-gb');

    export default {
        name: "ReportsUsersSale",
        components: {Backer, DatePicker, DownloadCsv: JsonCSV},
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                date_range: [],
                picked_date_range: null,
                picked_salesperson: null,
                salespersonOptions: [],
                sale_type_options: [
                    {value: null, text: "ALL SALE TYPES"},
                    {value: 'regular', text: "REGULAR SALES"},
                    {value: 'layaway', text: "LAYAWAY SALES"}
                ],
                picked_sale_type: null,
                details: [
                    {value: 1, text: "SUMMARY"},
                    {value: 2, text: "DETAILED REFUNDS"},
                    {value: 3, text: "DETAILED SALES"},
                    {value: 4, text: "PER INVOICE SALES"},
                ],
                invoice_options: [
                    {value: null, text: "ALL"},
                    {value: 1, text: "WRITTEN"},
                    {value: 2, text: "DELIVERED"},
                ],
              fixed_columns_dict: {
                            salesperson: "SALESPERSON",
                            locuser: "LOCATION | SALESPERSON",
                            location_name: "LOCATION",
                            total_sales_count: "NO OF SALES",
                            total_without_tax: "GROSS SALES",  // Changed from "TOTAL SALE"
                            total_refunded_without_tax: "TOTAL REFUNDED",
                            total_short_amount: "SHORT AMOUNT", 
                            net_sales: "NET SALES",  // NEW: Net Sales column
                            total_sales_tax: "SLS TAX",
                            total_refunded_st: "SLS TAX REFUNDED",
                            total_cc_sales: "CC SALES",
                            total_finance_sales: "FIN SALES",
                            total_cash_sales: "CASH SALES",
                            total_cc_refunds: "CC REFUNDS",
                            total_finance_refunds: "FIN REFUNDS",
                            total_cash_refunds: "CASH REFUNDS",
                            invoice_id: "INVOICE #",
                            lease_ids: "LEASE IDS",
                            lease_company: "LEASE COMPANY",
                            is_layaway: "SALE TYPE",
                            layaway_sales_amount: "LAYAWAY TOTAL",  // Total layaway sales
                            layaway_paid_so_far: "LAYAWAY PAID",    // NEW: Layaway paid so far
                            regular_sales_amount: "REGULAR SALES"
                        },
                columns: [],
                picked_location_id: null,
                details_filter: null,
                picked_invoice_type: null,
                currentPage: 1,
                perPage: 50,
                sortColumn: null,
                sortDirection: 'asc',
                comparisonData: null,
                comparisonLoading: false,
                previousPeriodData: null
            }
        },
        computed: {
               itemsWithCalculations() {
        return this.items.map(item => {
            // Calculate Net Sales (Gross Sales - Refunds)
            const grossSales = parseFloat(item.total_without_tax || 0);
            const refunds = parseFloat(item.total_refunded_without_tax || 0);
            const netSales = grossSales - refunds;
            
            // Calculate Layaway Paid So Far (for layaway items)
            let layawayPaidSoFar = 0;
            if (item.is_layaway || item.was_layaway || item.layaway_sales_amount) {
                // For layaway items, paid amount = total sales - remaining balance
                // You might need to adjust this calculation based on your data structure
                layawayPaidSoFar = grossSales - (item.layaway_balance_remaining || 0);
            }
            
            return {
                ...item,
                net_sales: netSales,
                layaway_paid_so_far: layawayPaidSoFar
            };
        });
    },
    
            itemsWithLocationNames() {
                return this.items.map(item => ({
                    ...item,
                    location_name: this.packet.locationsdict[item.location_id] || `Location ${item.location_id}`
                }));
            },
            filteredLocations() {
                if (!this.packet.locations) return [];

                const excludedLocationNames = [
                    'FOLCROFT WH',
                    '101 WH',
                    '9TH ST WH',
                    'OUT OF STOCK',
                    'MECCA SHIPPING',
                    'ONLINE SALES'
                ];

                return this.packet.locations.filter(location =>
                    !excludedLocationNames.includes(location.text)
                );
            },
            salespeople() {
                if (this.items.length > 0) {
                    const salespeople = [...new Set(this.items.map(item => item.salesperson))];
                    return salespeople.map(sp => ({
                        value: sp,
                        text: this.formatSalespersonName(sp)
                    })).sort((a, b) => a.text.localeCompare(b.text));
                }
                return [];
            },
            filteredItems() {
                return this.items.filter(item => this.allowed_row(item));
            },
            paginatedItems() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.sortedItems.slice(start, end);
            },
            sortedItems() {
                if (!this.sortColumn) return this.filteredItems;

                return [...this.filteredItems].sort((a, b) => {
                    let aVal = a[this.sortColumn];
                    let bVal = b[this.sortColumn];

                    if (this.isNumericColumn(this.sortColumn)) {
                        aVal = parseFloat(aVal || 0);
                        bVal = parseFloat(bVal || 0);
                    }

                    if (this.sortColumn === 'salesperson') {
                        aVal = this.formatSalespersonName(aVal);
                        bVal = this.formatSalespersonName(bVal);
                    }

                    if (this.sortColumn === 'locuser') {
                        aVal = this.formatLocationUser(a);
                        bVal = this.formatLocationUser(b);
                    }

                    if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
                    if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
                    return 0;
                });
            },
            totalPages() {
                return Math.ceil(this.filteredItems.length / this.perPage);
            },
            paginationStart() {
                return (this.currentPage - 1) * this.perPage + 1;
            },
            paginationEnd() {
                const end = this.currentPage * this.perPage;
                return end > this.filteredItems.length ? this.filteredItems.length : end;
            },
            showFooter() {
                return this.details_filter !== 4 && this.filteredItems.length > 0;
            },
            // Sales Comparison (Total Sales)
            salesComparison() {
                return this.calculateComparison('total_without_tax');
            },
            // Refunds Comparison
            refundsComparison() {
                return this.calculateComparison('total_refunded_without_tax');
            },
            // Layaway Comparison - FIXED: Use the new backend fields
            layawayComparison() {
                if (!this.items.length || !this.previousPeriodData) {
                    return this.getEmptyComparison();
                }

                // Use the new backend fields for layaway amounts
                const currentLayawayTotal = this.items.reduce((sum, item) =>
                    sum + parseFloat(item.layaway_sales_amount || 0), 0
                );

                // For previous period, we need to calculate from the raw data
                const previousLayawayTotal = this.previousPeriodData.reduce((sum, item) => {
                    // Check if the new field exists, otherwise fall back to old calculation
                    if (item.layaway_sales_amount !== undefined) {
                        return sum + parseFloat(item.layaway_sales_amount || 0);
                    } else {
                        // Fallback: calculate from individual invoices
                        return sum + ((item.is_layaway === true || item.was_layaway === true) ? parseFloat(item.total_without_tax || 0) : 0);
                    }
                }, 0);

                const difference = currentLayawayTotal - previousLayawayTotal;
                const percentage = previousLayawayTotal > 0 ? (difference / previousLayawayTotal) * 100 :
                                 currentLayawayTotal > 0 ? 100 : 0;

                return {
                    currentTotal: currentLayawayTotal,
                    previousTotal: previousLayawayTotal,
                    difference: difference,
                    percentage: Math.abs(percentage),
                    trend: difference > 0 ? 'increase' : difference < 0 ? 'decrease' : 'same'
                };
            }
        },
        watch: {
            currentPage() {
                this.$nextTick(() => {
                    const table = this.$el.querySelector('.data-table-container');
                    if (table) {
                        table.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            },
            filteredItems() {
                this.currentPage = 1;
            },
            items() {
                this.salespersonOptions = this.salespeople;
            }
        },
        methods: {
            calculateComparison(field) {
                if (!this.items.length || !this.previousPeriodData) {
                    return this.getEmptyComparison();
                }

                const currentTotal = this.items.reduce((sum, item) =>
                    sum + parseFloat(item[field] || 0), 0
                );

                const previousTotal = this.previousPeriodData.reduce((sum, item) =>
                    sum + parseFloat(item[field] || 0), 0
                );

                const difference = currentTotal - previousTotal;
                const percentage = previousTotal > 0 ? (difference / previousTotal) * 100 :
                                 currentTotal > 0 ? 100 : 0;

                return {
                    currentTotal,
                    previousTotal,
                    difference: difference,
                    percentage: Math.abs(percentage),
                    trend: difference > 0 ? 'increase' : difference < 0 ? 'decrease' : 'same'
                };
            },

            getEmptyComparison() {
                return {
                    currentTotal: 0,
                    previousTotal: 0,
                    difference: 0,
                    percentage: 0,
                    trend: 'same'
                };
            },

           allowed_cols: function(){
    let cols = [];
    if (this.details_filter == 1){
        cols = [
            'salesperson', 
            'location_name', 
            'total_sales_count', 
            'total_without_tax',  // Gross Sales
            'net_sales',          // NEW: Net Sales
            'total_short_amount',
            'total_refunded_without_tax', 
            'total_sales_tax', 
            'total_refunded_st', 
            'total_cc_sales', 
            'total_finance_sales', 
            'total_cash_sales'
        ];
        
        // Add layaway columns
        if (this.items.some(item => item.layaway_sales_amount !== undefined)) {
            cols.push('layaway_sales_amount', 'layaway_paid_so_far', 'regular_sales_amount');
        } else {
            cols.push('is_layaway');
        }
    }
    if (this.details_filter == 2){
        cols = [
            'salesperson', 
            'location_name', 
            'total_sales_count', 
            'total_without_tax',  // Gross Sales
            'net_sales',          // NEW: Net Sales
            'total_refunded_without_tax', 
            'total_sales_tax', 
            'total_refunded_st'
        ];
        let total_refunds_prefixes = this.columns.filter(function(d){ return d.split("_")[0] == "total" && d.split("_")[2] == "refunds"});
        cols = cols.concat(total_refunds_prefixes);
        let total_fsg_refunds =  this.columns.filter(function(d){ return d.split(" ")[0] == "REFUNDS"});
        cols = cols.concat(total_fsg_refunds);
        // Show layaway indicator in refunds view
        cols.push('is_layaway');
    }
    if (this.details_filter == 3){
        cols = [
            'salesperson', 
            'location_name', 
            'total_sales_count', 
            'total_without_tax',  // Gross Sales
            'net_sales',          // NEW: Net Sales
            'total_refunded_without_tax', 
            'total_sales_tax', 
            'total_refunded_st'
        ];
        let total_sales_prefixes = this.columns.filter(function(d){ return d.split("_")[0] == "total" && d.split("_")[2] == "sales"});
        cols = cols.concat(total_sales_prefixes);
        let total_fsg_sales =  this.columns.filter(function(d){ return d.split(" ")[0] == "SALES"});
        cols = cols.concat(total_fsg_sales);
        // Show layaway indicator in sales view
        cols.push('is_layaway');
    }
    if (this.details_filter == 4) {
        cols = [
            'salesperson',
            'location_name',
            'total_sales_count',
            'invoice_id',
            'lease_ids',
            'lease_company',
            'total_without_tax',  // Gross Sales
            'net_sales',          // NEW: Net Sales
            'total_refunded_without_tax',
            'total_sales_tax',
            'total_refunded_st',
            'total_cash_sales',
            'total_cc_sales',
            'total_finance_sales',
            'is_layaway'
        ];
        const dynamicSales = this.columns.filter(d => d.startsWith('SALES ('));
        cols = cols.concat(dynamicSales);
    }
    return cols;
},
            allowed_row: function(item){
                let status = true;
                if (this.picked_location_id != null){
                    if (item.location_id != this.picked_location_id){
                        status = false;
                    }
                }
                if (this.picked_salesperson != null){
                    if (item.salesperson !== this.picked_salesperson){
                        status = false;
                    }
                }
                // Fix: Show layaway sales when "All Sale Types" is selected
                if (this.picked_sale_type === 'layaway') {
                    if (!item.is_layaway && !item.was_layaway && !item.layaway_sales_amount) {
                        status = false;
                    }
                } else if (this.picked_sale_type === 'regular') {
                    if (item.is_layaway || item.was_layaway || item.layaway_sales_amount) {
                        status = false;
                    }
                }
                return status;
            },
            set_dates: function(value){
                let start = null;
                let end = null;

                if(value == 'today'){
                    start = moment().format("MM-DD-YYYY")
                    end = moment().format("MM-DD-YYYY")
                }
                if(value == 'yesterday'){
                    start = moment().add(-1, 'days').format("MM-DD-YYYY")
                    end = moment().add(-1, 'days').format("MM-DD-YYYY")
                }
                if(value == 'this_week'){
                    start = moment().startOf('week').format("MM-DD-YYYY")
                    end = moment().endOf('week').format("MM-DD-YYYY")
                }
                if(value == 'last_week'){
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY")
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY")
                }
                if(value == 'this_month'){
                    start = moment().startOf('month').format("MM-DD-YYYY")
                    end = moment().endOf('month').format("MM-DD-YYYY")
                }
                if(value == 'last_month'){
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY")
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY")
                }

                if (start && end) {
                    this.date_range = [start, end]
                    this.picked_date_range = value;
                    this.fetch_init();
                }
            },
            getPreviousDateRange() {
                if (!this.date_range || this.date_range.length !== 2) return null;

                const startDate = moment(this.date_range[0], "MM-DD-YYYY");
                const endDate = moment(this.date_range[1], "MM-DD-YYYY");

                const daysDiff = endDate.diff(startDate, 'days') + 1;

                const previousStart = startDate.clone().subtract(daysDiff, 'days');
                const previousEnd = endDate.clone().subtract(daysDiff, 'days');

                return [
                    previousStart.format("MM-DD-YYYY"),
                    previousEnd.format("MM-DD-YYYY")
                ];
            },
            getPreviousDateRangeText() {
                const previousRange = this.getPreviousDateRange();
                return previousRange ? previousRange.join(' to ') : '—';
            },

            fetchComparisonData() {
                return new Promise((resolve) => {
                    const previousDateRange = this.getPreviousDateRange();
                    if (!previousDateRange) {
                        this.previousPeriodData = [];
                        resolve();
                        return;
                    }

                    let that = this;
                    let data = {
                        dates: previousDateRange,
                        location_id: this.picked_location_id,
                        picked_invoice_type: this.picked_invoice_type,
                        details_filter: this.details_filter,
                        sale_type: null,  // Get all sale types for comparison
                        salesperson: this.picked_salesperson,
                        username: this.packet.userDetails.username,
                        include_sales_count: true
                    };

                    let path = "/api/reports/reports_users_sale/";

                    that.comparisonLoading = true;

                    let successCallback = function(response) {
                        if (response && response.data && response.data.result) {
                            that.previousPeriodData = response.data.result;
                            console.log('Previous period data received:', that.previousPeriodData);
                        } else {
                            that.previousPeriodData = [];
                        }
                        that.comparisonLoading = false;
                        resolve();
                    }

                    let errorCallback = function(error) {
                        console.error("Error fetching comparison data:", error);
                        that.previousPeriodData = [];
                        that.comparisonLoading = false;
                        resolve();
                    }

                    Requestor.postSyncP(path, data, this, successCallback, errorCallback);
                });
            },

            fetch_init() {
                if (!this.details_filter || this.details_filter === "null") {
                    this.$bvToast.toast('Please select a report type.', {
                        title: 'Invalid Filter',
                        variant: 'warning',
                        solid: true
                    });
                    return;
                }

                if (!this.date_range || this.date_range.length !== 2){
                    this.$bvToast.toast('Please select a date range.', {
                        title: 'Invalid Date Range',
                        variant: 'warning',
                        solid: true
                    });
                    return;
                }

                let dates = this.date_range;
                let location_id = this.picked_location_id;
                let salesperson = this.picked_salesperson;

                let that = this;
                let data = {
                    dates: dates,
                    location_id: location_id,
                    picked_invoice_type: this.picked_invoice_type,
                    details_filter: this.details_filter,
                    sale_type: this.picked_sale_type,
                    salesperson: salesperson,
                    username: this.packet.userDetails.username,
                    include_sales_count: true
                };

                let path = "/api/reports/reports_users_sale/";

                this.items_being_loaded = true;

                // First fetch comparison data, then fetch current data
                this.fetchComparisonData().then(() => {
                    // Now fetch the current data
                    let successCallback = function(response) {
                        if (response.data.result){
                            that.items = response.data.result;
                            console.log('Current period data received:', that.items);
                            that.derive_sorted_columns();
                        } else {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        that.items_being_loaded = false;
                    }

                    let errorCallback = function(error) {
                        console.log(error);
                        that.$bvToast.toast(
                            "Error occurred. Please try again.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.items_being_loaded = false;
                    }

                    Requestor.postSyncP(path, data, this, successCallback, errorCallback);
                });
            },

            derive_sorted_columns: function(){
                if (this.items.length > 0){
                    let dcs = Object.keys(this.items[0]);
                    var columns = ["salesperson", "location_id", "total_sales_count", "total_without_tax", "total_refunded_without_tax", "total_sales_tax", "total_refunded_st"];

                    // Add the new layaway amount fields if they exist
                    if (dcs.includes('layaway_sales_amount')) {
                        columns.push('layaway_sales_amount', 'regular_sales_amount');
                    }

                    let total_sales_prefixes = dcs.filter(function(d){ return d.split("_")[0] == "total" && d.split("_")[2] == "sales"});
                    columns = columns.concat(total_sales_prefixes);

                    let total_fsg_sales =  dcs.filter(function(d){ return d.split(" ")[0] == "SALES"});
                    columns = columns.concat(total_fsg_sales);

                    let total_refunds_prefixes = dcs.filter(function(d){ return d.split("_")[0] == "total" && d.split("_")[2] == "refunds"});
                    columns = columns.concat(total_refunds_prefixes);

                    let total_fsg_refunds =  dcs.filter(function(d){ return d.split(" ")[0] == "REFUNDS"});
                    columns = columns.concat(total_fsg_refunds);

                    this.columns = columns;
                }
            },
            sortByColumn(col) {
                if (this.sortColumn === col) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                } else {
                    this.sortColumn = col;
                    this.sortDirection = 'asc';
                }
            },
            isSortableColumn(col) {
                return !['invoice_id', 'lease_ids', 'lease_company'].includes(col);
            },
            get_csv_data() {
                return this.items
                    .filter(item => this.allowed_row(item))
                    .map(item => {
                    const row = {};
                    this.allowed_cols().forEach(col => {
                        const header = this.fixed_columns_dict[col] || col;

                        if (col === 'salesperson') {
                            row[header] = this.formatSalespersonName(item[col]);
                        } else if (col === 'location_id') {
                            row[header] = this.packet.locationsdict[item[col]] || item[col];
                        } else if (['invoice_id', 'lease_ids', 'lease_company'].includes(col)) {
                            row[header] = item[col] || '—';
                        } else if (col === 'total_sales_count') {
                            row[header] = this.formatSalesCount(item[col]);
                        } else if (col === 'is_layaway') {
                            row[header] = item[col] ? 'Layaway' : 'Regular';
                        } else {
                            const num = item[col] != null ? parseFloat(item[col]) : 0;
                            row[header] = num.toFixed(2);
                        }
                    });
                    return row;
                    });
            },
            get_csv_filename() {
                let now = moment().format("YYYY-MM-DD_HHmmss");
                let name_prefix = "salespeople_summary";
                if (this.details_filter == 2) {
                    name_prefix = "salespeople_detailed_refunds";
                } else if (this.details_filter == 3) {
                    name_prefix = "salespeople_detailed_sales";
                } else if (this.details_filter == 4) {
                    name_prefix = "salespeople_per_invoice_sales";
                }

                // Add sale type to filename
                if (this.picked_sale_type === 'layaway') {
                    name_prefix += '_layaway';
                } else if (this.picked_sale_type === 'regular') {
                    name_prefix += '_regular';
                }

                return `${name_prefix.toUpperCase()}_${now}.csv`;
            },
            getTableTitle() {
                const titles = {
                    1: 'Salespeople Summary',
                    2: 'Salespeople Detailed Refunds',
                    3: 'Salespeople Detailed Sales',
                    4: 'Salespeople Per Invoice Sales'
                };
                let title = titles[this.details_filter] || 'Salespeople Reports';

                // Add sale type to title
                if (this.picked_sale_type === 'layaway') {
                    title += ' - Layaway Sales';
                } else if (this.picked_sale_type === 'regular') {
                    title += ' - Regular Sales';
                }

                return title;
            },
            formatCurrency(value) {
                const num = parseFloat(value || 0);
                return num.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            },
            formatSalesCount(value) {
                const count = parseInt(value || 0);
                return count.toLocaleString('en-US');
            },
            formatSalespersonName(username) {
                if (!username) return '—';
                return username.split('.').map(part =>
                    part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
                ).join(' ');
            },
            formatLocationUser(item) {
                const locationName = this.packet.locationsdict[item.location_id] || `Location ${item.location_id}`;
                const salespersonName = this.formatSalespersonName(item.salesperson);
                return `${locationName} | ${salespersonName}`;
            },
           getHeaderClass(col) {
    const numericCols = [
        'total_sales_count', 'total_without_tax', 'net_sales', 'total_refunded_without_tax', 
        'total_sales_tax', 'total_refunded_st', 'total_cc_sales', 'total_finance_sales', 
        'total_cash_sales', 'layaway_sales_amount', 'layaway_paid_so_far', 'regular_sales_amount'
    ];
    if (numericCols.includes(col)) return 'text-end';
    if (col === 'salesperson') return 'text-start';
    return 'text-center';
},

            getHeaderStyle(col) {
                if (col === 'salesperson') return 'min-width: 180px;';
                if (col === 'locuser') return 'min-width: 250px;';
                if (['invoice_id', 'lease_ids', 'lease_company'].includes(col)) return 'min-width: 120px;';
                if (col === 'total_sales_count') return 'min-width: 100px;';
                if (col === 'is_layaway') return 'min-width: 90px;';
                if (['layaway_sales_amount', 'regular_sales_amount'].includes(col)) return 'min-width: 120px;';
                return 'min-width: 100px;';
            },
      getCellClass(col, value) {
    let classes = [];
    const numericCols = [
        'total_sales_count', 'total_without_tax', 'net_sales', 'total_refunded_without_tax', 
        'total_sales_tax', 'total_refunded_st', 'total_cc_sales', 'total_finance_sales', 
        'total_cash_sales', 'layaway_sales_amount', 'layaway_paid_so_far', 'regular_sales_amount','total_short_amount' 
    ];

    if (numericCols.includes(col)) classes.push('text-end');
    if (col === 'salesperson') classes.push('text-start');
    if (col.includes('refund') && parseFloat(value) > 0) classes.push('text-danger');
      if (col === 'total_short_amount' && parseFloat(value) > 0) classes.push('text-danger');
    if (col.includes('sales') && parseFloat(value) > 0 && col !== 'total_sales_count') classes.push('text-success');
    if (col === 'total_sales_count' && parseInt(value) > 0) classes.push('text-info');
    if (col === 'layaway_sales_amount' && parseFloat(value) > 0) classes.push('text-warning');
    if (col === 'layaway_paid_so_far' && parseFloat(value) > 0) classes.push('text-success');
    if (col === 'regular_sales_amount' && parseFloat(value) > 0) classes.push('text-primary');
    if (col === 'net_sales') {
        const netVal = parseFloat(value);
        if (netVal > 0) classes.push('text-success');
        else if (netVal < 0) classes.push('text-danger');
    }

    return classes.join(' ');
},
            getRowClass(item) {
                const netAmount = parseFloat(item.total_without_tax || 0) - parseFloat(item.total_refunded_without_tax || 0);
                if (netAmount < 0) return 'table-danger';
                if (netAmount > 10000) return 'table-success';
                if (item.is_layaway === true || item.was_layaway === true || (item.layaway_sales_amount && item.layaway_sales_amount > 0)) return 'table-warning-light';
                return '';
            },
            isNumericColumn(col) {
                const nonNumericCols = ['salesperson', 'locuser', 'location_id', 'invoice_id', 'lease_ids', 'lease_company', 'is_layaway'];
                return !nonNumericCols.includes(col);
            },
            columnTotal(col) {
                if (!this.isNumericColumn(col)) return 0;
                return this.filteredItems.reduce((sum, item) => sum + parseFloat(item[col] || 0), 0);
            },
            getDateRangeText() {
                if (!this.date_range || this.date_range.length !== 2) return '';
                return `${this.date_range[0]} to ${this.date_range[1]}`;
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);

            const startOfMonth = moment().startOf('month').format("MM-DD-YYYY");
            const today = moment().format("MM-DD-YYYY");
            this.date_range = [startOfMonth, today];
        },
    }
</script>
<style scoped>
/* Base container styles */
.filter-group .col {
    min-width: 180px;
}

.filter-group {
    margin-bottom: 1rem;
}

.filter-label {
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.25rem;
    display: block;
}

.quick-date-btn {
    padding: 4px 8px;
    font-size: 11px;
    border: 1px solid #dc3545;
    color: #dc3545;
    background: white;
}

.quick-date-btn:hover:not(.active) {
    background: #f8f9fa;
}

.quick-date-btn.active {
    background: #dc3545;
    color: white;
}

/* Comparison Cards - FIXED CONTAINMENT */
.comparison-card {
    border: none;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: transform 0.2s, box-shadow 0.2s;
    border-radius: 8px;
    overflow: hidden; /* Prevent content from overflowing */
    height: 100%;
    display: flex;
    flex-direction: column;
}

.comparison-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.sales-card {
    border-top: 4px solid #007bff;
}

.refunds-card {
    border-top: 4px solid #dc3545;
}

.layaway-card {
    border-top: 4px solid #ffc107;
}

.comparison-body {
    padding: 1.25rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Prevent overflow */
}

.comparison-title {
    font-size: 1rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
    margin-bottom: 1rem;
    flex-shrink: 0; /* Prevent title from shrinking */
}

/* Comparison Grid Layout */
.comparison-grid {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden; /* Prevent grid overflow */
}

/* Periods Row - Current vs Previous */
.periods-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 1rem;
    flex-shrink: 0; /* Prevent row from shrinking */
}

.period-box {
    text-align: center;
    padding: 12px 8px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    min-height: 70px; /* Fixed height for consistency */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.period-label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
    line-height: 1.2;
}

.period-value {
    font-size: 1.1rem;
    font-weight: bold;
    line-height: 1.2;
    word-break: break-word; /* Prevent long numbers from breaking layout */
}

/* Metrics Row - Difference & Growth */
.metrics-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    flex-shrink: 0; /* Prevent row from shrinking */
}

.metric-box {
    text-align: center;
    padding: 10px 8px;
    background: white;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    min-height: 60px; /* Fixed height for consistency */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.metric-label {
    font-size: 10px;
    font-weight: 600;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
    line-height: 1.2;
}

.metric-value {
    font-size: 0.95rem;
    font-weight: bold;
    line-height: 1.2;
    word-break: break-word; /* Prevent long content from breaking layout */
}

.metric-value i {
    font-size: 0.8rem;
    margin-left: 2px;
}

/* Date Info */
.date-info {
    font-size: 10px;
    text-align: center;
    margin-top: auto; /* Push to bottom */
    padding-top: 0.75rem;
    border-top: 1px solid #e9ecef;
    flex-shrink: 0; /* Prevent shrinking */
}

.date-info strong {
    color: #495057;
}

/* Data Table Styles - FIXED CONTAINMENT */
.data-table-container {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    max-width: 100%; /* Ensure table doesn't overflow container */
}

.table {
    margin-bottom: 0; /* Remove default margin */
    width: 100%; /* Ensure table uses full width */
}

.table th {
    font-weight: 600;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
    padding: 8px 12px;
}

.table td {
    vertical-align: middle;
    padding: 8px 12px;
    max-width: 200px; /* Prevent cells from becoming too wide */
    overflow: hidden;
    text-overflow: ellipsis;
}

.table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
}

/* Layaway specific styles */
.table-warning-light {
    background-color: rgba(255, 193, 7, 0.05) !important;
}

/* Sort button styling */
.btn-link {
    text-decoration: none;
}

.btn-link:hover {
    text-decoration: none;
}

/* Pagination styling */
.pagination {
    margin-bottom: 0;
}

/* Loading state improvements */
.b-overlay {
    min-height: 200px;
}

.text-start {
    text-align: left !important;
}

/* Color states for trends */
.text-success {
    color: #28a745 !important;
}

.text-danger {
    color: #dc3545 !important;
}

.text-warning {
    color: #ffc107 !important;
}

.text-primary {
    color: #007bff !important;
}

.text-secondary {
    color: #6c757d !important;
}

.text-muted {
    color: #6c757d !important;
}

/* Main container fixes */
.card {
    overflow: visible; /* Allow shadows to show */
}

.card-body {
    overflow: visible;
}

/* Row and column fixes */
.row {
    margin-left: 0;
    margin-right: 0;
}

.col-md-4 {
    padding-left: 8px;
    padding-right: 8px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .filter-group .row > div {
        margin-bottom: 10px;
    }

    .table-responsive {
        font-size: 12px;
    }

    .comparison-card {
        margin-bottom: 15px;
    }

    .comparison-body {
        padding: 1rem;
    }

    .periods-row,
    .metrics-row {
        gap: 8px;
    }

    .period-box,
    .metric-box {
        padding: 8px 6px;
        min-height: 60px; /* Adjust for mobile */
    }

    .period-value {
        font-size: 1rem;
    }

    .metric-value {
        font-size: 0.9rem;
    }

    .comparison-title {
        font-size: 0.9rem;
    }

    .period-label {
        font-size: 10px;
    }

    .metric-label {
        font-size: 9px;
    }

    .col-md-4 {
        padding-left: 6px;
        padding-right: 6px;
    }
}

/* Additional responsive tweaks for very small screens */
@media (max-width: 576px) {
    .periods-row,
    .metrics-row {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .comparison-body {
        padding: 0.75rem;
    }

    .date-info {
        font-size: 9px;
    }

    .period-box,
    .metric-box {
        min-height: 55px; /* Smaller on very small screens */
    }

    .table td,
    .table th {
        padding: 6px 8px;
        font-size: 11px;
    }
}

/* Prevent horizontal scrolling on main container */
.container-fluid,
.container {
    overflow-x: hidden;
}

/* Ensure proper box sizing */
* {
    box-sizing: border-box;
}

/* Fix for bootstrap card padding */
.card {
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/ReportsUsersSale.vue